import {Dictionary} from 'favorlogic-utils';

import {PickupLineOptionState} from 'types/model/pickupLine/PickupLineOptionState';

export const PICKUP_LINE_PLANNING_FORM_NAME = 'pickupLinePlanningForm';

export interface PickupLinePlanningFormValues {
    states: Dictionary<number, Dictionary<number, PickupLineOptionState>>;
}
